import React  from 'react';
import PropTypes from 'prop-types';
import '../../YsDialog/YsDialog.scss';
import DialogContainer from './DialogContainer'

class TitleDialog extends React.Component {
    render() {
        const {
            confirmLabel = '确定',
            cancelLabel,
            show,
            title,
            content,
            confirm,
            cancel,
        } = this.props;
        return (
            <section className={show?'dis-show':'dis-hide'}>
                <div className="dialog dialog-tips dialog-width-big">
                    {/*<header className="dialog-header"></header>*/}
                    <div className="dialog-body">
                        <div className="dialog-title">{title}</div>
                        <div className="dialog-main">
                            <p dangerouslySetInnerHTML={{__html:content}}>
                            </p>
                        </div>
                    </div>
                    <div className="dialog-operate">
                        {cancelLabel&&<button className="cancel"
                                              onClick={() => cancel()}>{cancelLabel}</button>}
                        <button className="confirm"
                                onClick={() => confirm()}>{confirmLabel}</button>
                    </div>
                </div>
                <div className="dialog-mask"></div>
            </section>
        )
    }
}

TitleDialog.propTypes = {
    confirmLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    title: PropTypes.string,
    show:PropTypes.boolean,
    content: PropTypes.string,
    confirm: PropTypes.func,     // called when ok button is clicked.
    cancel: PropTypes.func,     // called when ok button is clicked.
}

export default DialogContainer(TitleDialog);


// WEBPACK FOOTER //
// ./src/components/yunshl/Dialog/TitleDialog.js